import { getAuth } from 'firebase/auth'
import { apiPost } from '@/composables/useApi'

/**
 * 文件操作 composable
 * 管理文件删除和音频下载
 */
export function useFileOperations() {
  async function handleDeleteFile(audioId) {
    if (!audioId) throw new Error('No audio ID provided')
    const authInstance = getAuth()
    if (!authInstance.currentUser) throw new Error('User not authenticated')

    await apiPost(`/api/files/${audioId}/delete`, {})
  }

  async function handleDownloadAudio(audioSrc, audioName) {
    const response = await fetch(audioSrc)
    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = audioName
    document.body.appendChild(a)
    a.click()
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  }

  return {
    handleDeleteFile,
    handleDownloadAudio
  }
}
